package com.ives.components.browse;

import com.er453r.hxcompo.Component;

import com.ives.components.thumb.DicomThumb;
import com.ives.utils.Remoting;
import com.ives.utils.Log.Log;

class DicomBrowse extends Component{
	public static var currentSource:String;

	private var sources:Array<String>;

	public function new() {
		Remoting.getSources(onSources);
	}

	private function onSources(sources:Array<String>){
		this.sources = sources;

		Log.debug('Available sources: ${sources.join(',')}');

		on(sourcesSelect, "change", onChange);

		onChange();
	}

	private function onChange(){
		currentSource = sourcesSelect.value;

		clear();

		Remoting.getAllIds(currentSource, onAllIds);
	}

	private function onAllIds(ids:Array<String>){
		Log.info('Got ${ids.length} ids');

		for(id in ids)
			append(new DicomThumb(id));
	}
}
